class Collision {
  constructor(cfg) {
    this.obstacle = cfg.obstacle;
    this.collisionNormal = cfg.collisionNormal;
  }
}

export default Collision;
